"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ const defaultTranslations = exports.defaultTranslations = {
    apply: 'Apply',
    brandsX: 'Brands ({count})',
    categoriesX: 'Categories ({count})',
    clear: 'Clear',
    clearAllFilters: 'Clear all filters',
    filter: 'Filter',
    inspirationCorner: 'Inspiration corner',
    readNow: 'Read now',
    showMore: 'Show more',
    showingResultsFor: 'Showing results for',
    showingXOutOfYProducts: 'Showing {value} out of {total} products',
    xProducts: '{value} products'
};
const translationsNamespace = exports.translationsNamespace = 'products_product-listing';
